import { Outlet } from "react-router-dom";

const VendorsParentPage = () => {
    return <Outlet />
}

export default VendorsParentPage;